module.exports = __webpack_public_path__ + "img/icon_pause_fullscreen.2a9b805e.png";